// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-stream {
  position: relative;
  width: 100%;
  height: 100%;
  background: #000;
  overflow: hidden;
  display: flex;
  align-items: stretch;
}

.stream-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  object-fit: cover;

  background: #000;
}

/* Grabaciones HLS: mostrar el encuadre completo (letterbox) en lugar de recortar */
.stream-video.stream-video--contain {
  object-fit: contain;
}

.stream-video.loading,
.stream-video.offline,
.stream-video.error,
.stream-video.placeholder {
  opacity: 0;
}

.stream-video.stream-video--contain.loading {
  opacity: 1;
}

.stream-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: white;
  font-size: 14px;
  text-align: center;
  padding: 20px;
  box-sizing: border-box;
}

.stream-overlay.placeholder {
  background: linear-gradient(135deg, #111111 0%, #0a0a0a 100%);
}

.stream-overlay.loading {
  /* Paleta XTAM (sin azules): mismo lenguaje que XTAMSpinner fullscreen / Grabaciones */
  background:
    linear-gradient(135deg, rgba(166, 27, 52, 0.12) 0%, transparent 52%),
    linear-gradient(135deg, #0a0a0a 0%, #111111 48%, #0a0a0a 100%);
}

.stream-overlay.offline {
  background: linear-gradient(135deg, #2d2d2d 0%, #1a1a1a 100%);
}

.stream-overlay.error {
  background: linear-gradient(135deg, #4a1515 0%, #2d1515 100%);
}

.stream-overlay.loading .xtam-spinner--small {
  padding: 16px 20px;
  gap: 12px;
}

.stream-overlay.loading .xtam-spinner__message {
  color: #e5e7eb;
}

.offline-icon,
.error-icon {
  width: 48px;
  height: 48px;
  opacity: 0.6;
}

.stream-info {
  position: absolute;
  top: 8px;
  left: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 10;
}

.stream-info.playback-time-info {
  top: auto;
  bottom: 10px;
  left: 10px;
}

.live-badge {
  padding: 4px 10px;
  background: #ef4444;
  color: white;
  font-size: 11px;
  font-weight: 600;
  border-radius: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  animation: pulse 2s infinite;
}

.live-badge.ws {
  background: #22c55e;
  animation: none;
}

/* Tiempo de avance e información de grabación */
.playback-time-badge {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  padding: 6px 12px;
  background: rgba(0, 0, 0, 0.82);
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  border-radius: 6px;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.5px;
  border: 1px solid rgba(255, 255, 255, 0.15);
}

.playback-time-elapsed {
  font-size: 14px;
}

.playback-time-total {
  color: rgba(255, 255, 255, 0.8);
  font-weight: 500;
}

.playback-time-utc {
  font-size: 11px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.85);
}

.playback-time-utc-label {
  color: rgba(255, 255, 255, 0.65);
  font-size: 10px;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.7; }
}

/* Camera info overlay on hover */
.video-stream::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60px;
  background: linear-gradient(transparent, rgba(0,0,0,0.7));
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.3s;
}

.video-stream:hover::after {
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/components/CameraVideoPlayer.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;;EAEZ,iBAAiB;;EAEjB,gBAAgB;AAClB;;AAEA,mFAAmF;AACnF;EACE,mBAAmB;AACrB;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,sFAAsF;EACtF;;kEAEgE;AAClE;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;EAC/B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA,iCAAiC;AACjC;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,yDAAyD;EACzD,oBAAoB;EACpB,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ","sourcesContent":[".video-stream {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  background: #000;\n  overflow: hidden;\n  display: flex;\n  align-items: stretch;\n}\n\n.stream-video {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n\n  object-fit: cover;\n\n  background: #000;\n}\n\n/* Grabaciones HLS: mostrar el encuadre completo (letterbox) en lugar de recortar */\n.stream-video.stream-video--contain {\n  object-fit: contain;\n}\n\n.stream-video.loading,\n.stream-video.offline,\n.stream-video.error,\n.stream-video.placeholder {\n  opacity: 0;\n}\n\n.stream-video.stream-video--contain.loading {\n  opacity: 1;\n}\n\n.stream-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  color: white;\n  font-size: 14px;\n  text-align: center;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n.stream-overlay.placeholder {\n  background: linear-gradient(135deg, #111111 0%, #0a0a0a 100%);\n}\n\n.stream-overlay.loading {\n  /* Paleta XTAM (sin azules): mismo lenguaje que XTAMSpinner fullscreen / Grabaciones */\n  background:\n    linear-gradient(135deg, rgba(166, 27, 52, 0.12) 0%, transparent 52%),\n    linear-gradient(135deg, #0a0a0a 0%, #111111 48%, #0a0a0a 100%);\n}\n\n.stream-overlay.offline {\n  background: linear-gradient(135deg, #2d2d2d 0%, #1a1a1a 100%);\n}\n\n.stream-overlay.error {\n  background: linear-gradient(135deg, #4a1515 0%, #2d1515 100%);\n}\n\n.stream-overlay.loading .xtam-spinner--small {\n  padding: 16px 20px;\n  gap: 12px;\n}\n\n.stream-overlay.loading .xtam-spinner__message {\n  color: #e5e7eb;\n}\n\n.offline-icon,\n.error-icon {\n  width: 48px;\n  height: 48px;\n  opacity: 0.6;\n}\n\n.stream-info {\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  z-index: 10;\n}\n\n.stream-info.playback-time-info {\n  top: auto;\n  bottom: 10px;\n  left: 10px;\n}\n\n.live-badge {\n  padding: 4px 10px;\n  background: #ef4444;\n  color: white;\n  font-size: 11px;\n  font-weight: 600;\n  border-radius: 4px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  animation: pulse 2s infinite;\n}\n\n.live-badge.ws {\n  background: #22c55e;\n  animation: none;\n}\n\n/* Tiempo de avance e información de grabación */\n.playback-time-badge {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n  padding: 6px 12px;\n  background: rgba(0, 0, 0, 0.82);\n  color: #fff;\n  font-size: 13px;\n  font-weight: 600;\n  border-radius: 6px;\n  font-variant-numeric: tabular-nums;\n  letter-spacing: 0.5px;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n}\n\n.playback-time-elapsed {\n  font-size: 14px;\n}\n\n.playback-time-total {\n  color: rgba(255, 255, 255, 0.8);\n  font-weight: 500;\n}\n\n.playback-time-utc {\n  font-size: 11px;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.playback-time-utc-label {\n  color: rgba(255, 255, 255, 0.65);\n  font-size: 10px;\n}\n\n@keyframes pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.7; }\n}\n\n/* Camera info overlay on hover */\n.video-stream::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 60px;\n  background: linear-gradient(transparent, rgba(0,0,0,0.7));\n  pointer-events: none;\n  opacity: 0;\n  transition: opacity 0.3s;\n}\n\n.video-stream:hover::after {\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
